import type { NextLinkProps } from "@components/ui/next-link/NextLink";

export const LinkStyles: NextLinkProps["sx"] = {
    w: "full",
    h: "full",
    textDecoration: "none",
    _hover: { textDecoration: "none" },
    _focus: { textDecoration: "none" },
    _active: { textDecoration: "none" },
    _visited: { textDecoration: "none" },
};

export const ProductTileTheme = {
    blackFriday: {
        surface: {
            backgroundColor: "black",
        },
        text: {
            color: "white",
        },
        textGray: {
            color: "var(--ec-colors-gray-300)",
        },
    },
};
